import { render, staticRenderFns } from "./usersModel.vue?vue&type=template&id=53dc6ea4&scoped=true&lang=pug&"
import script from "./usersModel.vue?vue&type=script&lang=js&"
export * from "./usersModel.vue?vue&type=script&lang=js&"
import style0 from "./usersModel.vue?vue&type=style&index=0&id=53dc6ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dc6ea4",
  null
  
)

export default component.exports